(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lume-homepage"] && !Shopify.designMode) return;
  try {
    

(function() {

  /* ── ADD TO CART (Shopify AJAX API) ── */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.lm-atc');
    if (!btn || btn.disabled) return;
    var variantId = btn.dataset.variant;
    var title = btn.dataset.title;
    if (!variantId) return;

    btn.disabled = true;
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg>';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });

      if (res.ok) {
        /* Refresh cart count in native Shopify header */
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        /* Update any cart count elements the theme renders */
        document.querySelectorAll('[data-cart-count], .cart-count, #cart-count, .lm-cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        lmToast(title + ' added to cart ✦');
        /* Dispatch event so theme cart drawer can open */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {
        lmToast('Could not add to cart — please try again');
      }
    } catch(err) {
      lmToast('Something went wrong — please try again');
    }

    setTimeout(function() {
      btn.disabled = false;
      btn.innerHTML = '<svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="6.5" y1="1" x2="6.5" y2="12"/><line x1="1" y1="6.5" x2="12" y2="6.5"/></svg>';
    }, 1800);
  });

  /* ── TOAST ── */
  function lmToast(msg) {
    var t = document.getElementById('lm-toast');
    if (!t) return;
    document.getElementById('lm-toast-msg').textContent = msg;
    t.classList.add('on');
    clearTimeout(t._timer);
    t._timer = setTimeout(function() { t.classList.remove('on'); }, 2800);
  }

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        if (en.isIntersecting) { en.target.classList.add('on'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.lm-rev').forEach(function(el) { io.observe(el); });
  } else {
    document.querySelectorAll('.lm-rev').forEach(function(el) { el.classList.add('on'); });
  }

  /* ── NAV SCROLL BEHAVIOUR (if theme nav visible) ── */
  var lmNavSel = 'header, .site-header, #shopify-section-header';
  var lmNav = document.querySelector(lmNavSel);
  if (lmNav) {
    window.addEventListener('scroll', function() {
      lmNav.classList.toggle('lm-nav-stuck', window.scrollY > 60);
    }, { passive: true });
  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
